"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$ = exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$outboundSchema = exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$inboundSchema = exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$ = exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$outboundSchema = exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$inboundSchema = void 0;
exports.getHousePriceIndexInAreaAreasHousePriceIndexGetSecurityToJSON = getHousePriceIndexInAreaAreasHousePriceIndexGetSecurityToJSON;
exports.getHousePriceIndexInAreaAreasHousePriceIndexGetSecurityFromJSON = getHousePriceIndexInAreaAreasHousePriceIndexGetSecurityFromJSON;
exports.getHousePriceIndexInAreaAreasHousePriceIndexGetRequestToJSON = getHousePriceIndexInAreaAreasHousePriceIndexGetRequestToJSON;
exports.getHousePriceIndexInAreaAreasHousePriceIndexGetRequestFromJSON = getHousePriceIndexInAreaAreasHousePriceIndexGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$;
(function (GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$) {
    /** @deprecated use `GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$inboundSchema` instead. */
    GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$.inboundSchema = exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$inboundSchema;
    /** @deprecated use `GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$outboundSchema` instead. */
    GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$.outboundSchema = exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$outboundSchema;
})(GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$ || (exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$ = GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$ = {}));
function getHousePriceIndexInAreaAreasHousePriceIndexGetSecurityToJSON(getHousePriceIndexInAreaAreasHousePriceIndexGetSecurity) {
    return JSON.stringify(exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$outboundSchema
        .parse(getHousePriceIndexInAreaAreasHousePriceIndexGetSecurity));
}
function getHousePriceIndexInAreaAreasHousePriceIndexGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetHousePriceIndexInAreaAreasHousePriceIndexGetSecurity' from JSON`);
}
/** @internal */
exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$inboundSchema = z.object({
    "filter[end_month]": z.string().optional(),
    "filter[start_month]": z.string().optional(),
    local_authority_district_code: z.string().optional(),
    postcode: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "filter[end_month]": "filterEndMonth",
        "filter[start_month]": "filterStartMonth",
        "local_authority_district_code": "localAuthorityDistrictCode",
    });
});
/** @internal */
exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$outboundSchema = z.object({
    filterEndMonth: z.string().optional(),
    filterStartMonth: z.string().optional(),
    localAuthorityDistrictCode: z.string().optional(),
    postcode: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        filterEndMonth: "filter[end_month]",
        filterStartMonth: "filter[start_month]",
        localAuthorityDistrictCode: "local_authority_district_code",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$;
(function (GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$) {
    /** @deprecated use `GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$inboundSchema` instead. */
    GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$.inboundSchema = exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$inboundSchema;
    /** @deprecated use `GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$outboundSchema` instead. */
    GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$.outboundSchema = exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$outboundSchema;
})(GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$ || (exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$ = GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$ = {}));
function getHousePriceIndexInAreaAreasHousePriceIndexGetRequestToJSON(getHousePriceIndexInAreaAreasHousePriceIndexGetRequest) {
    return JSON.stringify(exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$outboundSchema.parse(getHousePriceIndexInAreaAreasHousePriceIndexGetRequest));
}
function getHousePriceIndexInAreaAreasHousePriceIndexGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetHousePriceIndexInAreaAreasHousePriceIndexGetRequest' from JSON`);
}
//# sourceMappingURL=gethousepriceindexinareaareashousepriceindexget.js.map